import { render, staticRenderFns } from "./Tramitar.vue?vue&type=template&id=4dfc98a0&"
import script from "./Tramitar.vue?vue&type=script&lang=js&"
export * from "./Tramitar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports